import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-24f78114"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    tabindex: "-1",
    class: "conversation__message-row"
};
const _hoisted_2 = { class: "conversation__message-icon" };
const _hoisted_3 = {
    key: 0,
    class: "conversation__message-media"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "conversation__message-bubble-dot-svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 0H0V3V4.5C0 6.433 1.567 8 3.5 8C5.433 8 7 6.433 7 4.5V3V2.6C7 1.16406 8.16406 0 9.6 0H7Z"
    })
], -1));
const _hoisted_5 = {
    key: 1,
    tabindex: "-1",
    class: "conversation__message-bubble"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "conversation__message-bubble-dot-svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 0H0V3V4.5C0 6.433 1.567 8 3.5 8C5.433 8 7 6.433 7 4.5V3V2.6C7 1.16406 8.16406 0 9.6 0H7Z"
    })
], -1));
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "conversation__message-footer" };
const _hoisted_9 = { class: "conversation__message-time text-align-right" };
const _hoisted_10 = {
    key: 0,
    class: "conversation__message-acks"
};
const _hoisted_11 = {
    key: 1,
    class: "conversation__message-input-container"
};
const _hoisted_12 = { tabindex: "-1" };
const _hoisted_13 = {
    key: 2,
    class: "conversation__message-agent"
};
const _hoisted_14 = { tabindex: "-1" };
const _hoisted_15 = {
    key: 3,
    class: "conversation__survey-container"
};
const _hoisted_16 = { tabindex: "-1" };
import ConversationItemForm from "@/components/ConversationItemForm.vue";
import ConversationItemInput from "@/components/ConversationItemInput.vue";
import ConversationItemMedia from "@/components/ConversationItemMedia.vue";
import ConversationSurvey from "@/components/ConversationSurvey.vue";
import DomUtil from "@/utils/dom.util";
// import {formatMessageTime, isOnlyEmojis} from '@/utils/index';
import { encodeHTML, formatMessageTime, isOnlyEmojis, parseMarkdown, parseUrls } from '@/utils/index';
import { AlertTriangle, Check, Clock, RotateCw } from 'lucide-vue-next';
import ConversationService from "@/services/conversation.service";
import { ConversationItemTypeEnum, MessageInboundState, MessageOutboundState } from "@/types/ConversationTypes";
import { AuthorType } from "@/types/UserTypes";
import { computed, ref } from "vue";
import { toast } from "../main";
import { t } from "@/utils/lang.util";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConversationItem',
    props: ['id', 'message'],
    emits: ['retry', 'deleted', 'formSubmitted', 'formDismissed', 'mediaLoaded'],
    setup(__props, { emit: emits }) {
        const props = __props;
        // const input = ref('')
        const visible = ref(true);
        // const ConversationItemTypeEnum: Ref<ConversationItemTypeEnum>  = ref(null)
        // const MessageInboundState: Ref<MessageInboundState> = ref(null)
        // const MessageOutboundState: Ref<MessageOutboundState> = ref(null)
        // const AuthorType: Ref<AuthorType> = ref(null)
        const isFromMe = computed(() => {
            return props.message.authorType === 'CUSTOMER';
        });
        const containsSingleEmoji = computed(() => {
            return props.message.body && isOnlyEmojis(props.message.body);
        });
        const messageBody = computed(() => {
            let body = (parseUrls(parseMarkdown(encodeHTML(props.message.body))));
            // let body = parse(props.message.body)
            // detect email message (when offline): example &#38;gt; On 31 Jan...
            const emailReplySeparator = body.indexOf('&#38;gt;');
            if (emailReplySeparator > 0) {
                return body.substring(0, emailReplySeparator - 2);
            }
            return body;
        });
        const avatarUrl = computed(() => {
            if (!props.message?.author?.avatarUrl)
                return null;
            return `${HOST}/api/conversations/${props.id}/avatar/${props.message.author.avatarUrl}`;
        });
        const HOST = process.env.VUE_APP_API_BASE_URI;
        const retryMessage = () => {
            emits('retry');
        };
        const formSubmitted = (obj) => {
            if (obj.success) {
                // setTimeout(() => {
                visible.value = false;
                emits('deleted', props.message.id);
                emits('formSubmitted', obj);
                DomUtil.focusConversationInputField();
            }
            else {
                toast.show(t('common.toast.generic_error'));
            }
        };
        const formDismissed = () => {
            visible.value = false;
            emits('formDismissed');
            DomUtil.focusConversationInputField();
        };
        const downloadFile = () => {
            ConversationService.loadMedia(props.id, props.message.id);
        };
        const mediaLoaded = (id) => {
            emits('mediaLoaded', id);
        };
        return (_ctx, _cache) => {
            const _component_BaseAvatar = _resolveComponent("BaseAvatar");
            const _component_BaseSpinner = _resolveComponent("BaseSpinner");
            const _directive_safe_html = _resolveDirective("safe-html");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["conversation__message-wrapper", { 'conversation__message--align-right': _unref(isFromMe) }])
                }, [
                    _withDirectives(_createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_BaseAvatar, {
                            name: __props.message.author?.nick || __props.message.author?.name,
                            url: _unref(avatarUrl),
                            isBot: __props.message.authorType === _unref(AuthorType).BOT || !__props.message.authorType,
                            authenticate: true
                        }, null, 8, ["name", "url", "isBot"])
                    ], 512), [
                        [_vShow, !_unref(isFromMe)]
                    ]),
                    _withDirectives(_createElementVNode("div", {
                        onClick: retryMessage,
                        class: "conversation__message-retry cursor-pointer"
                    }, [
                        _createVNode(_unref(RotateCw), { size: "18" })
                    ], 512), [
                        [_vShow, _unref(isFromMe) && __props.message.status === 'SENT-FAILURE']
                    ]),
                    (__props.message.type === _unref(ConversationItemTypeEnum).MESSAGE)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass({ 'conversation__message-visitor': _unref(isFromMe), 'conversation__message-agent': !_unref(isFromMe) })
                        }, [
                            (__props.message.media)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _hoisted_4,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.media, (media) => {
                                        return (_openBlock(), _createElementBlock("div", { key: media }, [
                                            _createVNode(ConversationItemMedia, {
                                                caption: _unref(messageBody),
                                                media: media,
                                                onRequestDownload: ($event) => (downloadFile(media)),
                                                onMediaLoaded: mediaLoaded
                                            }, null, 8, ["caption", "media", "onRequestDownload"])
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _hoisted_6,
                                    (__props.message.status === _unref(MessageInboundState).TYPING)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createVNode(_component_BaseSpinner, {
                                                size: "is-medium",
                                                loading: __props.message.status === _unref(MessageInboundState).TYPING,
                                                delay: 0.1
                                            }, null, 8, ["loading", "delay"])
                                        ]))
                                        : (_unref(messageBody))
                                            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["conversation__message-body", { 'conversation__message-body--emojiCap': _unref(containsSingleEmoji) }]),
                                                style: { "white-space": "pre-line" }
                                            }, null, 2)), [
                                                [_directive_safe_html, _unref(messageBody)]
                                            ])
                                            : _createCommentVNode("", true)
                                ])),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatMessageTime)(__props.message.ts)), 1),
                                (_unref(isFromMe))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        (__props.message.status === _unref(MessageOutboundState).SENDING || __props.message.status === _unref(MessageOutboundState).DRAFT)
                                            ? (_openBlock(), _createBlock(_unref(Clock), {
                                                key: 0,
                                                size: "12",
                                                class: "conversation__message-ack-icon"
                                            }))
                                            : (__props.message.status === _unref(MessageOutboundState).SENT)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createVNode(_unref(Check), {
                                                        size: "12",
                                                        class: "conversation__message-ack-icon"
                                                    }),
                                                    _createVNode(_unref(Check), {
                                                        size: "12",
                                                        class: "conversation__message-ack-icon"
                                                    })
                                                ], 64))
                                                : (__props.message.status === _unref(MessageOutboundState).READ)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createVNode(_unref(Check), {
                                                            size: "12",
                                                            class: "conversation__message-ack-icon",
                                                            title: "read"
                                                        }),
                                                        _createVNode(_unref(Check), {
                                                            size: "12",
                                                            class: "conversation__message-ack-icon"
                                                        })
                                                    ], 64))
                                                    : (__props.message.status === _unref(MessageOutboundState).SENT_FAILURE)
                                                        ? (_openBlock(), _createBlock(_unref(AlertTriangle), {
                                                            key: 3,
                                                            size: "12",
                                                            class: "conversation__message-ack-icon"
                                                        }))
                                                        : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 2))
                        : (__props.message.type === _unref(ConversationItemTypeEnum).INPUT_FIELD)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(ConversationItemInput, { message: __props.message }, null, 8, ["message"])
                                ])
                            ]))
                            : (__props.message.type === _unref(ConversationItemTypeEnum).FORM)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createVNode(ConversationItemForm, {
                                            message: __props.message,
                                            onSubmit: formSubmitted,
                                            onDismiss: formDismissed
                                        }, null, 8, ["message"])
                                    ])
                                ]))
                                : (__props.message.type === _unref(ConversationItemTypeEnum).CHAT_CLOSED)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            _createVNode(ConversationSurvey, {
                                                id: __props.id,
                                                onRated: _ctx.processRatingConversation
                                            }, null, 8, ["id", "onRated"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                ], 2)
            ], 512)), [
                [_vShow, visible.value]
            ]);
        };
    }
});
